import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompanyState } from '../_reducers/company.reducers';

const getCompanyFeatureState = createFeatureSelector<CompanyState>('company');

export const getCompaniesLoading = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.companiesLoading
);


/**
 * Select companies
 */
export const getCompanies = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.companies
);

export const getCrossDomainCompanies = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.crossDomainCompanies
);

export const getCompaniesDatatable = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.datatable
);

export const getCompanyUsersDatatable = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.usersDatatable
);

export const getCompanyDetails = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.companyDetails
);

export const getAddPaymentMethodResponse = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.addPaymentMethodResponse
);

export const getCancelCompanySubscriptionResponse = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.cancelCompanySubscriptionResponse
);

/**
 * Select error
 */
export const getError = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.error
);

/**
 * Select operations
 */
export const getCompanyOperations = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.operations
);

export const getDomainValidityStatus = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.domainValidity
);

export const getDomainStatus = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.domainStatus
);

export const getCreateDomainResponse = createSelector(
  getCompanyFeatureState,
  (state: CompanyState) => state?.createSuccess
);